<template>
    <div class="modal-dialog modal-lg" v-if="showModal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Nuevo Empleado</h4>
                <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-sm-23" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Patrón</label>
                                <select class="form-select" v-model="form.employer_id" v-bind:class="formSubmitted ? errors.employer_id ? 'is-invalid' : 'is-valid' : ''">
                                    <option v-for="(employer, index) in employers" :key="index" :value="employer.id">{{ employer.name }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors.employer_id">{{ errors.employer_id }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Nombre</label>
                                <input class="form-control" type="text" v-model="form.name" v-bind:class="formSubmitted ? errors.name ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.name = form.name.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="mb-3">
                                <label>Puesto</label>
                                <select class="form-select" v-model="form.employee_position_id" v-bind:class="formSubmitted ? errors.employee_position_id ? 'is-invalid' : 'is-valid' : ''">
                                    <option v-for="(job_position, index) in job_positions" :key="index" :value="job_position.id">{{ job_position.name }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors.employee_position_id">{{ errors.employee_position_id }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="storeEmployeeValidation">Registrar Empleado</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

export default {
    name: 'employee_modal',
    mixins: [validations, modalCleanupMixin],
    components: {
        
    },
    data(){
        return{
            showModal: true,
            employer_id: 0,
            employers: [],
            job_positions: []
        }
    },
    beforeMount: async function() {
        this.clearForm();

        let response = await ws.getPositions(); 

        if(response.type == "success"){
            this.job_positions = response.data;
        }

        let response2 = await ws.getEmployers(); 

        if(response2.type == "success"){
            this.employers = response2.data;

            this.employer_id = this.employers.length > 0 ? this.employers[0].id : 0;
        }
    },
    methods: {
        async loadEmployer(employer_id) {
            this.form.employer_id = employer_id;
        },
        async storeEmployee(form) {
            let response = await ws.storeEmployee(form.name, form.employer_id, form.employee_position_id);

            if(response.type == "success"){
                this.$toast.success(response.message);
                
                this.showModal = false;

                let employee = response.data;
            
                this.closeModalAndRedirect('/panel/'+employee.id+'/employee');
            }
            else{
                this.$toast.error(response.message);
            }
        },
    }
}
</script>